<span *ngIf="isAndroid" class="android-prominent-disclosure">
  Hospitable collects and uses personal data, including images that you choose to share with us, in accordance with our
  <a href="https://hospitable.com/privacy" target="_blank">Privacy Policy</a>
  Images are solely used for specific purposes such as displaying user profile pictures, or sending images to your
  guests or team. We will not use these images for any other purposes.
</span>
